export interface IIndexedData<T> {
  [index: string]: T;
}
